import { getAnalyticsPaymentMethodTypeFromType } from '../machines/helpers';
import { AnalyticsEventActions, AnalyticsEventFeatures } from '../typings/analytics';
const getMakeAPaymentEvent = (baseConfirmationEvent, paymentResponse, paymentFormValues) => ({
    event: Object.assign(Object.assign({}, baseConfirmationEvent), { confirmation: paymentResponse.paymentId, payment_type: paymentFormValues.paymentType, payment_submit_date: paymentFormValues.paymentSubmitDate, payment_scheduled_date: paymentFormValues.paymentScheduledDate, one_click_autopay: paymentFormValues.oneClickAutopay })
});
const getAutopayEnrollEvent = (baseConfirmationEvent, autopayValues) => ({
    event: Object.assign(Object.assign({}, baseConfirmationEvent), { effective_date: autopayValues.effectiveDueDate, next_due_date: autopayValues.nextDueDate })
});
const getAutopayCancelEvent = (baseEvent, autopayValues) => ({
    event: Object.assign(Object.assign({}, baseEvent), { action: AnalyticsEventActions.CONFIRMATION, autopay_status: autopayValues.autopayStatus })
});
const getAddPaymentMethodEvent = (baseEvent, paymentFrom, paymentMethodType) => {
    return {
        event: Object.assign(Object.assign({}, baseEvent), { action: AnalyticsEventActions.CONFIRMATION, payment_method_type: getAnalyticsPaymentMethodTypeFromType(paymentMethodType), payment_from: paymentFrom })
    };
};
const getDeletePaymentMethodEvent = (baseEvent, paymentMethod) => {
    return {
        event: Object.assign(Object.assign({}, baseEvent), { action: AnalyticsEventActions.CONFIRMATION, payment_method_type: getAnalyticsPaymentMethodTypeFromType(paymentMethod.type), last_4_of_acct: paymentMethod.cardNumberLast4 || paymentMethod.bankAccountNumberLast4 })
    };
};
// Keep this, max line 50 doesnt help much in this case. Splitting increases complexity
// eslint-disable-next-line max-lines-per-function
export const getConfirmationEventCreator = (autopayValues, baseEvent, paymentFormValues, paymentOptionObj, paymentResponse) => {
    const baseConfirmationEvent = Object.assign(Object.assign(Object.assign({}, baseEvent), paymentOptionObj), { action: AnalyticsEventActions.CONFIRMATION, payment_amount: paymentFormValues.paymentAmount, payment_method_type: paymentFormValues.paymentMethodType, payment_from: paymentFormValues.paymentFrom });
    let getEvent;
    switch (baseEvent.feature) {
        case AnalyticsEventFeatures.MAKE_A_PAYMENT:
            getEvent = () => getMakeAPaymentEvent(baseConfirmationEvent, paymentResponse, paymentFormValues);
            break;
        case AnalyticsEventFeatures.ENROLL_AUTOPAY:
        case AnalyticsEventFeatures.MODIFY_AUTOPAY:
            getEvent = () => getAutopayEnrollEvent(baseConfirmationEvent, autopayValues);
            break;
        case AnalyticsEventFeatures.CANCEL_AUTOPAY:
            getEvent = () => getAutopayCancelEvent(baseEvent, autopayValues);
            break;
        case AnalyticsEventFeatures.ADD_PAYMENT_METHOD:
            getEvent = (paymentFrom, paymentMethodType) => getAddPaymentMethodEvent(baseEvent, paymentFrom, paymentMethodType);
            break;
        case AnalyticsEventFeatures.DELETE_PAYMENT_METHOD:
            getEvent = (paymentMethod) => getDeletePaymentMethodEvent(baseEvent, paymentMethod);
            break;
        default:
            getEvent = () => {
                throw new Error(`No confirmation event object implemented for ${baseEvent.feature}`);
            };
    }
    return getEvent;
};
